import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { ObjectEntity } from './object.entity';
import { RbacActionObjectCrudEntity } from './rbac-action-object-crud.entity';
import { RbacActionEntity } from './rbac-action.entity';

@Index('_fk__rbac_role__id', ['fkRbacActionId', 'fkObjectId'], { unique: true })
@Index('_fk__rbac_roles__id', ['fkRbacActionId'], {})
@Index('_rbac_role_ob1jects_ibfk_2', ['fkObjectId'], {})
@Entity('_rbac_action__object')
export class RbacActionObjectEntity extends BaseEntity {
	@Column('int', { name: '_fk__rbac_action__id', unsigned: true })
	public fkRbacActionId!: number;

	@Column('int', { name: '_fk__object__id', nullable: true, unsigned: true })
	public fkObjectId!: number | null;

	@Column('varchar', { name: '_custom_resource', length: 64, nullable: true })
	public customResource!: string | null;

	@ManyToOne(
		() => RbacActionEntity,
		(rbacAction) => rbacAction.rbacActionObjects,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk__rbac_action__id', referencedColumnName: 'id' }])
	public fkRbacAction!: RbacActionEntity;

	@ManyToOne(() => ObjectEntity, (object) => object.rbacActionObjects, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__object__id', referencedColumnName: 'id' }])
	public fkObject!: ObjectEntity;

	@OneToMany(
		() => RbacActionObjectCrudEntity,
		(rbacActionObjectCrud) => rbacActionObjectCrud.fkRbacActionObject,
		{},
	)
	public rbacActionObjectCruds!: Array<RbacActionObjectCrudEntity>;
}
